import { useTranslation } from "react-i18next";
import { Button, Flex, Tooltip } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { Handbook } from "features/handbook/model/handbook";
import styles from "./HandbookTable.module.css";

type Props = {
  row: Handbook;
  isAttached: boolean;
  showAttachButton?: boolean;
  onAttachToService?: (row: Handbook) => void;
  showDetachButton?: boolean;
  onDetachFromService?: (row: Handbook) => void;
  onEdit?: (row: Handbook) => void;
  onDelete?: (row: Handbook) => void;
};

export const HandbookRowActions = ({
  row,
  isAttached,
  showAttachButton,
  onAttachToService,
  showDetachButton,
  onDetachFromService,
  onEdit,
  onDelete,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Flex gap="small" justify="flex-end">
      {showAttachButton && onAttachToService && !isAttached && (
        <Tooltip title={t("handbook.table.add")}>
          <Button
            variant="dashed"
            danger
            style={{ backgroundColor: "orange" }}
            type="primary"
            shape="circle"
            icon={<PlusOutlined />}
            aria-label={t("handbook.table.add")}
            onClick={() => onAttachToService(row)}
          />
        </Tooltip>
      )}

      {showDetachButton && onDetachFromService && (
        <Tooltip title={t("handbook.table.remove")}>
          <Button
            variant="dashed"
            danger
            style={{ backgroundColor: "orange" }}
            type="primary"
            shape="circle"
            icon={<MinusOutlined />}
            aria-label={t("handbook.table.remove")}
            onClick={() => onDetachFromService(row)}
          />
        </Tooltip>
      )}

      <Tooltip title={t("handbook.table.edit")}>
        <Button
          className={styles.iconBtn}
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
          aria-label={t("handbook.table.edit")}
          onClick={() => onEdit?.(row)}
        />
      </Tooltip>

      {!onDetachFromService && (
        <Tooltip title={t("handbook.table.delete")}>
          <Button
            className={styles.iconBtnDanger}
            danger
            type="primary"
            shape="circle"
            icon={<DeleteOutlined />}
            aria-label={t("handbook.table.delete")}
            onClick={() => onDelete?.(row)}
          />
        </Tooltip>
      )}
    </Flex>
  );
};
